import React from 'react';
import {meal} from '../../constants'
import {BsFillPlayFill,BsPauseFill} from 'react-icons/bs'
import './Intro.css';

const Intro = () => {
  const [playVideo,setPlayVideo]=React.useState(false);
  const vidRef = React.useRef();
  return(
    <div className='vid'>
      <video 
      ref={vidRef}
      src={meal}
      loop
      type='video/mp4'
      controls={false}
      muted
      />
      <div className='vid-overlay flex__center'>
        <div
        className='vid-overlay-circle flex__center'
        onClick={()=>{
          setPlayVideo(!playVideo);
          if (playVideo){vidRef.current.pause()
          }else{vidRef.current.play()}
        }}>
          {playVideo ? (<BsPauseFill color='#fff' fontSize={30}/>) : (<BsFillPlayFill color='#fff' fontSize={30}/>)}
        </div>
      </div>
    </div>
  )

};


export default Intro;
